import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'app-ios-chrome-warning-dialog',
  imports: [MatButtonModule, MatDialogModule, IconComponent],
  templateUrl: './ios-chrome-warning-dialog.component.html',
  styleUrl: './ios-chrome-warning-dialog.component.scss',
})
export class IosChromeWarningDialogComponent {
  private dialogRef = inject(MatDialogRef<IosChromeWarningDialogComponent>);

  continue() {
    this.dialogRef.close();
  }
}
